export const DEVICE_TYPES = {
    MOBILE: "mobile",
    TABLET: "tablet",
    DESKTOP: "desktop",
};
